import { render, staticRenderFns } from "./SimpleTextWidget.vue?vue&type=template&id=251e64df&scoped=true&"
import script from "./SimpleTextWidget.vue?vue&type=script&lang=ts&"
export * from "./SimpleTextWidget.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTextWidget.vue?vue&type=style&index=0&id=251e64df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e64df",
  null
  
)

export default component.exports